import { where } from "firebase/firestore";
import { Collection, WhereField } from '../../shared/constants';
import { addDoc, getAllDocsByQueries, updateDoc } from './collectionBaseWorker';

export const getHistoryByProductId = async ({ productId }) => {
    return getAllDocsByQueries({
        collection: Collection.PRODUCT_INVENTORY_HISTORY,
        queries: [
            where(WhereField.PRODUCT_ID, "==", productId)
        ]
    })
}

export const getHistoryByParkIdAndCategoryName = async ({ collection, estacionamentoId, categoryName }) => {
    return await getAllDocsByQueries({
        collection: collection, queries: [
            where(WhereField.PARKID, "==", estacionamentoId),
            where(WhereField.NAME, '==', categoryName)
        ]
    })
}

export const updateProductHistoryById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.PRODUCT_INVENTORY_HISTORY, id: id, data: data })
}

export const addProductHistory = async ({ data }) => {
    console.log(data);
    await addDoc({ collection: Collection.PRODUCT_INVENTORY_HISTORY, data: data })
}